export const removeNbsp = (str: string = "") =>
  str
    .split("")
    .map((element: string, i: number) => {
      if (str.charCodeAt(i) === 160) {
        return " ";
      }
      return element;
    })
    .join("");

export const qetStringQueryParam = (name: string) => {
  //@ts-ignore
  const scriptURLString = document?.getElementById("search-form-script")?.src;

  return scriptURLString ? new URL(scriptURLString).searchParams.get(name) : "";
};

export const getBooleanQueryParam = (name: string, defaultValue: boolean) => {
  //@ts-ignore
  const scriptURLString = document?.getElementById("search-form-script")?.src;
  const searchParam =
    scriptURLString && new URL(scriptURLString).searchParams.get(name);

  if (searchParam === "Y") {
    return true;
  }
  if (searchParam === "N") {
    return false;
  }
  return defaultValue;
};

export const applicationFormUrl = (origin: string): string => {
    return process.env.REACT_APP_APPLICATION_FORM_URL || origin;
};
